



























































































































import JsonViewer from 'vue-json-viewer'
import { Vue, Component } from "vue-property-decorator";
import {Mutation, Getter} from "vuex-class";
import axios from "axios";
import moment from "moment";

@Component({
    components: {
        JsonViewer
    }
})
export default class ViewDataset extends Vue {
    name= "ViewDataset";
    @Getter base_url !: any;
    @Getter auth_header !: any;
    @Getter token !: any;
    @Getter math_service_url !: any;
    @Getter currentExperimentalDatasetID !: any;
    @Getter validationParameters !: any;
    @Mutation SET_BREADCRUMB!: (_ : any) => any;
    @Mutation CHANGE_EXPERIMENTAL_DATASET_ID!: (_ : any) => any;
    currentExperimentalDataset:any =  {}
    currentExperimentalPlan:any =  {}
    assesmentMethods: any = []

    mounted () {
        this.setBreadcrumb();
        if (this.$route.params.id) {
            this.currentExperimentalDataset.id = this.$route.params.id;
        }
        else {
            console.log("OpenExperimentalDataset view no router params.id")
            this.currentExperimentalDataset.id = this.currentExperimentalDatasetID
            this.$router.push({ name: "ViewDataset", params: {id:this.currentExperimentalDatasetID} });
        }

        //set ExperimentalDataset id in vuex
        this.setExperimentalDatasetId()
        this.getExperimentalDataset();
    }

    moment(val: any){
        return moment(val);
    }

    setExperimentalDatasetId(){
        this.CHANGE_EXPERIMENTAL_DATASET_ID(this.currentExperimentalDataset.id)
    }

    setBreadcrumb(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    }

    getExperimentalDataset(){
        let datasetUrl = this.math_service_url+"dataset/"+
            this.currentExperimentalDataset.id+"/info";
        console.log("GET from ",datasetUrl);
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get(
                datasetUrl,
                {
                    headers: {
                        jwt: this.token
                    },
                    withCredentials: true
                }
            )
            .then(
                response => {
                    console.log("Got response",response);
                    this.currentExperimentalDataset = response.data.dataset;
                    this.currentExperimentalPlan = response.data.plan;

                    this.assesmentMethods = response.data.template.ams;

                    for(let am of this.assesmentMethods){
                        am.csvFile = {};
                    }
                    //sort assesment method array
                    this.assesmentMethods.sort(function(a:any, b:any) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        // names must be equal
                        return 0;
                    }
                );
            })
            .catch(
                error => {
                    console.log("error on GET dataset info", error);
                }
            );
    }

    get valParamSet(){
        var valParamSet = new Set()
        this.assesmentMethods.forEach(function(method: any) {
            valParamSet.add(method.validation_parameter_display)
        })
        var arr = Array.from(valParamSet)
        arr.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
        return arr
    }

    viewData(assessmentMethod: any){
        console.log("View data of am with id",assessmentMethod);
        this.$router.push({ name: "ViewInput", params: {
            dataset_id: this.currentExperimentalDataset.id,
            am_name: assessmentMethod.amname,
            am_display: assessmentMethod.name,
            validation_parameter_display: assessmentMethod.validation_parameter_display
        } });
    }

    haveAmInput(assessmentMethod: any, event: any){
        assessmentMethod.csvFile = event.target.files[0]
        event.target.value = "";
        console.log("Have input for am",assessmentMethod, assessmentMethod.csvFile.name, event);
        const formData = new FormData();
        formData.append("file", assessmentMethod.csvFile);
        let fileUploadUrl = this.math_service_url+"dataset/"+
            this.currentExperimentalDataset.id+"/file";
        let mainThis = this;
        axios.post(fileUploadUrl, formData, {
            headers: {
                jwt: this.token
            },
            withCredentials: true})
            .then(function (result) {
                console.log("File uploaded",result);
                mainThis.saveFileAsCsvInputForAm(assessmentMethod, result.data);
            }, function (error) {
                console.log("File upload failed.",error);
            });
    }

    saveFileAsCsvInputForAm(am: any, fileIdData: any) {
        /*
        public class InputPartRequest {
            public AMName amName;
            public InputPartType type;
            public String content;

            public InputPartRequest() {
            }
        }
        */
        let request = {
            amName : am.amname,
            type : "CSV_FILE",
            content: JSON.stringify(fileIdData)
        }
        let fileUploadUrl = this.math_service_url+"dataset/"+
            this.currentExperimentalDataset.id+"/input-part";
        let mainThis = this;
        axios.put(fileUploadUrl, request, {
            headers: {
                jwt: this.token
            }
        })
            .then(function (result) {
                console.log("File saved as inputpart",result);
                am.csvUploaded = true;
            }, function (error) {
                console.log("PUT inputpart failed.",error);
            });
    }

    archiveDataset(){
        console.log("Going to archive dataset")
    }

    back() {
        this.$router.push({ name: "ViewAllExperimentalDatasets", params: {} });
    }

    accordionAction(id:string) {
        let elementById:any = document.getElementById(id);
        let accordionButton = elementById;
        let contentOfAccordion = elementById.nextSibling;
        if (contentOfAccordion.style.display == "block") {
            contentOfAccordion.style.display = "none";
            accordionButton.classList.remove("is-primary");
        } else if (contentOfAccordion.style.display == "none") {
            contentOfAccordion.style.display = "block";
            accordionButton.classList.add("is-primary");
        } else if(contentOfAccordion.style.display == "") {
            contentOfAccordion.style.display = "block";
            accordionButton.classList.add("is-primary");
        }

        // accordionButton class
        let otherAccordions = Array.from(document.getElementsByClassName("accordionButton"));
        otherAccordions.forEach(function(otherAccordionButton){
            if(accordionButton != otherAccordionButton){
                let content: any = otherAccordionButton.nextSibling;
                content.style.display = "none";
                otherAccordionButton.classList.remove("is-primary");
            }

        })

    }

}
